import React from 'react'
import {
  Select,
  Input,
  Form,
  Button,
  Divider,
  message,
  Anchor,
  Spin,
  Pagination,
  Table
} from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import { getParmUrl, getCookieNew } from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './brand-qualification-list.module.less'
import './index.less'
const Option = Select.Option
// 接口文档地址 http://confluence.vsigo.cn/pages/viewpage.action?pageId=62753109
class BrandQualificationList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      spinLoading: true,
      total: 0,
      paramData: {
        'supplier_code':getCookieNew('supplier_code'),
        'brand_name': '',
        'is_warning': null,
        'status': '',
        'page_index': 1,
        'page_size': 10
      },
      tableData: [],
      brandArr: [], // 品牌的数据
      statusdArr: [
        {
          name: '编辑',
          value: 'edit'
        },
        {
          name: '待审核',
          value: 'on_check'
        },
        {
          name: '审核通过',
          value: 'pass_check'
        },
        {
          name: '审核不通过',
          value: 'refuse_check'
        }
      ],
      isWaranningArr: [
        {
          name: '是',
          value: 1
        },
        {
          name: '否',
          value: 0
        }
      ]
    }
  }

  componentDidMount () {
    this.setState({
      spinLoading: false
    })
    this.getQueryBrand()
    this.getTableList()
  }

  // 获取列表数据
  getTableList =async () => {
    let {paramData, tableData} = this.state
    this.setState({
      spinLoading: true
    })
    try {
      let res = await ajaxApi({
        url: common.SapUrl + 'brand-qua/query-list',
        params: paramData
      })
      this.setState({
        spinLoading: false
      })
      // console.log(res)
      if (res.status === 200) {
        let _data = res.data.data
        if (_data && _data.length !== 0) {
          _data.map((item, index) => {
            item.key = index
          })
          this.setState({
            tableData: _data,
            total: res.data.page_num
          })
        } else {
          this.setState({
            tableData: []
          })
        }
      }
    } catch (e) {
      this.setState({
        spinLoading: false
      })
      console.log(e)
    }
  }

  // 查询品牌
  getQueryBrand = async () => {
    let {brandArr} = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-brand',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          brandArr: res.data.data
        })
      } else {
        this.setState({
          brandArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 获取输入框的值
  handleChangeInput=(e, name) => {

  }

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let {paramData} = this.state
    paramData[name] = e
    this.setState({
      paramData
    })
  }

  // 查询
  handleSearch=() => {
    let {paramData} = this.state
    paramData.page_index = 1
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 重置
  handleReset=() => {
    let {paramData} = this.state
    paramData.brand_name = ''
    paramData.is_warning = null
    paramData.status = ''
    paramData.page_index = 1
    paramData.page_size = 10
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 换页
  pageChage=(page, pagesize) => {
    let {paramData} = this.state
    paramData.page_index = page
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 调整页数
  onShowSizeChange=(current, pageSize) => {
    try {
      let { paramData } = this.state
      paramData.page_size = pageSize
      paramData.page_index = current
      this.setState({
        paramData
      }, () => {
        this.getTableList()
      })
    } catch (error) {
      console.log(error)
    }
  }

  render () {
    const columns = [
      {
        title: '品牌名称',
        dataIndex: 'brand_name',
        key: 'brand_name',
        render: (text, record) => <span>{record.brand_name ? record.brand_name : '-'}</span>
      },
      {
        title: '编辑人',
        dataIndex: 'moder',
        key: 'moder',
        render: (text, record) => <span>{record.moder ? record.moder : '-'}</span>
      },
      {
        title: '编辑时间',
        dataIndex: 'mod_time',
        key: 'mod_time',
        render: (text, record) => <span>{record.mod_time ? moment(record.mod_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
      },
      {
        title: '审核状态',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => <span>{record.status === 'edit' ? '编辑' : record.status === 'on_check' ? '待审核' : record.status === 'pass_check' ? '审核通过' : '审核不通过' }</span>
      },
      {
        title: '过期预警',
        dataIndex: 'warning',
        key: 'warning',
        render: (text, record) => <a style={{color: record.warning > 0 ? 'red' : '#40a9ff'}} href={'/main/brandqualification/brand-qualification-edit?supplier_code=' + getCookieNew('supplier_code') + '&&brand_id=' + record.brand_id + '&&status=' + record.status}>{record.warning}</a>
      }
    ]
    return (
      <div className="brand">
        <Spin spinning={this.state.spinLoading}>
          <div className="search">
            <section>
            <span className={styles.publicspan}>商品品牌：</span>
            <Select
              showSearch
              // mode="multiple"
              onKeyDown={this.onKeyup}
              style={{ width: 196, marginRight: '0px' }}
              optionFilterProp="children"
              placeholder='请选择'
              value={this.state.paramData.brand_name}
              onChange={(e) => this.handelChangeSource(e, 'brand_name')}
            >
              <Option key={0} name='brand_name' value=''>请选择</Option>
              {this.state.brandArr || this.state.brandArr.length === 0 ? this.state.brandArr.map((item, index) => (
                <Option key={index + 1} name='brand_name' value={item.name}>{item.name}</Option>
              )) : null}
            </Select>

            <span className={styles.publicspan}>是否过期：</span>
            <Select
              showSearch
              // mode="multiple"
              onKeyDown={this.onKeyup}
              style={{ width: 196, marginRight: '0px' }}
              optionFilterProp="children"
              placeholder='请选择'
              value={this.state.paramData.is_warning}
              onChange={(e) => this.handelChangeSource(e, 'is_warning')}
            >
              <Option key={0} name='is_warning' value={null}>请选择</Option>
              {this.state.isWaranningArr || this.state.isWaranningArr.length === 0 ? this.state.isWaranningArr.map((item, index) => (
                <Option key={index + 1} name='is_warning' value={item.value}>{item.name}</Option>
              )) : null}
            </Select>

            <span className={styles.publicspan}>状态：</span>
            <Select
              showSearch
              // mode="multiple"
              onKeyDown={this.onKeyup}
              style={{ width: 196, marginRight: '0px' }}
              optionFilterProp="children"
              placeholder='请选择'
              value={this.state.paramData.status}
              onChange={(e) => this.handelChangeSource(e, 'status')}
            >
              <Option key={0} name='status' value=''>请选择</Option>
              {this.state.statusdArr || this.state.statusdArr.length === 0 ? this.state.statusdArr.map((item, index) => (
                <Option key={index + 1} name='status' value={item.value}>{item.name}</Option>
              )) : null}
            </Select>
            <span style={{float: 'right'}}>
              <Button
                type="primary"
                shape="round"
                style={{ marginLeft: '28px' }}
                onKeyDown={this.onKeyup}
                onClick={this.handleSearch}
              >
              查询
              </Button>
              <Button
                type=""
                shape="round"
                style={{ margin: '0px 8px' }}
                onClick={this.handleReset}
              >
              重置
              </Button>
            </span>
          </section>
          </div>
          <div className="brandBody">
            <section style={{ marginTop: '24px' }}>
              <Table
                bordered={false}
                onChange={this.handleSort}
                rowKey={(record) => record.key}
                dataSource={this.state.tableData}
                pagination={false}
                columns={columns}
              ></Table>
              <div className={styles.page}>
                <span
                  style={{
                    position: 'absolute',
                    left: '2px',
                    top: '-4px',
                    fontSize: '14px'
                  }}
                >
                  <span>共</span>
                  <span>{this.state.total}</span>
                  <span>条记录</span>
                </span>
                <Pagination
                  current={this.state.paramData.page_index}
                  showQuickJumper
                  total={this.state.total}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  onChange={this.pageChage}
                />
              </div>
            </section>
          </div>
        </Spin>
      </div>
    )
  }
}
export default BrandQualificationList



// WEBPACK FOOTER //
// ./src/pages/brandqualification/brand-qualification-list.js